export default __webpack_public_path__ + "static/media/ic_user.3d724cc3.svg";